import { OrganizationType } from 'globalTypes';

import Organization from 'entities/Organization';
import apiRequest from 'lib/apiRequest';
import Collection from 'lib/Collection';

class Organizations extends Collection<Organization> {
  initialize() {
    // @ts-expect-error ts-migrate(2740) FIXME: Type 'typeof Organization' is missing the followin... Remove this comment to see the full error message
    this.model = Organization;
  }

  static suggest(): Promise<Organizations> {
    return apiRequest('/organizations/suggested', 'GET').then((response) =>
      Organizations.fromJSON(response)
    ) as Promise<Organizations>;
  }

  static search(
    queryType: OrganizationType,
    query: string,
    page: number = 1,
    perPage: number = 100,
    include_approval_settings: boolean = false
  ) {
    const options: {
      type: string;
      query: string;
      include_approval_settings?: boolean;
      page: number;
      per_page: number;
    } = {
      type: queryType.toLowerCase(),
      query,
      page,
      per_page: perPage,
    };

    // by the time the ruby backend gets this, any value, even 'false' winds up being interpreted as a true
    // sending no value at all for this arg gets us the false we're after
    if (include_approval_settings) {
      options.include_approval_settings = true;
    }

    return apiRequest('/organizations/find', 'GET', options).then((response) =>
      Organizations.fromJSON(response)
    ) as Promise<Organizations>;
  }
}

export default Organizations;
